import { RUN_LOGOUT, RUN_COUNTRY,SET_COUNTRY, RUN_LOGIN, RUN_LOGIN_WITH_HASH, RUN_STATE_LOAD, SET_INFO, SET_STATE, GET_TOKEN, RUN_FORGOT_PASSWORD, RUN_RESET_PASSWORD_FROM_HASH, RUN_CHANGE_PASSWORD, RUN_USER_LOGIN_2FA } from '../types'
import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'
import * as types from '@/types'
import { Const } from '../plugins/commonAll/provider/lib/const.cls'

export const actions = {
    [RUN_LOGIN]({ commit, state, getters, dispatch }, credentials) {
        _executeApi(Enpoints.EP_LOGIN, credentials, '', commit, (error, result) => {
            if (!error) {
				if (parseInt(result.res_data.user.profile.gAuthenticatorEnabled) == 0){ 
					credentials.localParams.parameter.pageLoader = true
                    result.res_data.user.loggedIn = true
                    commit(SET_STATE, result.res_data.user)
                    commit(Const.SET_STATE_REFRESH_DATA, '0')
                    localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
                    credentials.localParams.parameter.$router.replace('/2fa-screen')
				}else if (parseInt(result.res_data.user.profile.gAuthenticatorEnabled) == 1 || parseInt(result.res_data.user.profile.gAuthenticatorEnabled) == 2) {
					credentials.localParams.parameter.faFlag = true
                    credentials.localParams.parameter.gAuthenticatorEnabled = '1'
					if(parseInt(result.res_data.user.profile.gAuthenticatorEnabled) == 2){
						credentials.localParams.parameter.faFlag = false
					}
                }
            } else {
                _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_COUNTRY]({ commit, state, getters, dispatch }, credentials) {
        RxFactory.getJson(process.env.LOCAL_COUNTRY_API, credentials.globalParams, '')
            .map(response => response.data)
            .subscribe(data => {
                credentials.localParams.parameter.pageLoader = false
                commit(SET_COUNTRY, data)
            },
            e => { _handleErrorResponse(e, commit) })
    },
    [RUN_LOGIN_WITH_HASH]({ commit, state, getters, dispatch }, credentials) {
        _executeApi(Enpoints.EP_LOGIN_WITH_HASH, credentials, '', commit, (error, result) => {
            if (!error) {
                _messageDisplayFunction(credentials.localParams.parameter, 'Ip add successfully', 'success')
            } else {
                _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_USER_LOGIN_2FA]({ commit, state, dispatch, getters }, credentials) {
        _executeApi(Enpoints.EP_USER_LOGIN_2FA, credentials, '', commit, (error, result) => {
            if (!error) {
                result.res_data.user.loggedIn = true
                commit(SET_STATE, result.res_data.user)
                commit(Const.SET_STATE_REFRESH_DATA, '0')
                localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
                /*if ((parseInt(result.res_data.user.lead_type) == 0 && parseInt(result.res_data.user.step) < 3) || (parseInt(result.res_data.user.lead_type) == 1 && parseInt(result.res_data.user.step) < 4)) {
                    credentials.localParams.parameter.$router.replace('/welcome')
                } else {
                    credentials.localParams.parameter.$router.replace('/home')
                }*/
                credentials.localParams.parameter.$router.replace('/home')
                // _messageDisplayFunction(credentials.localParams.parameter, 'login successfully', 'success')
            } else {
                _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_STATE_LOAD]({ commit, state, getters, dispatch }, credentials) {
        const data = {}
        let user = localStorage.getItem('user')
        if (user) {
            user = atob(user)
            user = JSON.parse(user)
        }
		if(credentials.localParams.page){	credentials.localParams.parameter.pageLoader = true  }
        commit(SET_STATE, user)
        if (user !== null && user !== '') {
            _executeApi(Enpoints.EP_FRESH_DATA, credentials, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
                if (!error) {
                    
                    result.res_data.user.loggedIn = true
                    commit(SET_STATE, result.res_data.user)
                    commit(Const.SET_STATE_REFRESH_DATA, '1')





                    localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
					if(credentials.localParams.page){
						credentials.localParams.parameter.pageLoader = false 	
					}
					
                    if(credentials.localParams.page == 'question'){
                        if(result.res_data.user.tier){
                            if([3,4].includes(parseInt(result.res_data.user.tier))){
                                return
                            }else if ([1].includes(parseInt(result.res_data.user.tier))){
                                credentials.localParams.parameter.$router.push('/individual-step3')
                            } else if ([2].includes(parseInt(result.res_data.user.tier))){
                                credentials.localParams.parameter.$router.push('/help-centre')
                            } else {
                                credentials.localParams.parameter.$router.push('/home')
                            }
                        }
                        
                    }
                    // Condition for tranfer token from fxview Client Crypto transfer
                    if(credentials.globalParams.api_query && credentials.globalParams.api_query.transfer && result.res_data.user.profile.walletInterface){
                        localStorage.removeItem('transfer_login')
                        credentials.localParams.parameter.$router.replace({ name: "crypto_deposit" }) 
                    }

					if(credentials.localParams.page && credentials.localParams.page == 'individual_doc_step'){
						credentials.localParams.parameter.tierFunc()
					}else if(credentials.localParams.page && credentials.localParams.page != 'individual_doc_step'){
						credentials.localParams.parameter.$router.replace({ name: "individual_step3_doc" }) 
					}

                    // console.log('after action====> ', getters[GET_TOKEN])

                } else {
                    
                    _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
                }
            })
        }
    },
    [RUN_LOGOUT]({ commit, state, getters, dispatch }, credentials) {
        _executeApi(Enpoints.EP_LOGOUT, credentials, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.pageLoader = true
                credentials.localParams.parameter.$root.$children[0].walletSessionTimeOut = false
                _handleLogout(result.res_data, commit, { router: credentials.localParams.parameter.$router, forward: true })
                _messageDisplayFunction(credentials.localParams.parameter, 'logout successfully', 'success')
            } else {
                _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_FORGOT_PASSWORD]({ commit, state, getters, dispatch }, credentials) {
        _executeApi(Enpoints.EP_FORGOT_PASSWORD, credentials, '', commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.resend = true
                _messageDisplayFunction(credentials.localParams.parameter, 'A link for change password has been sent on your registered email id', 'success')
            } else {
                _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_RESET_PASSWORD_FROM_HASH]({ commit, state, dispatch, getters }, credentials) {
        _executeApi(Enpoints.EP_RESET_PASSWORD_FROM_HASH, credentials, '', commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.displayMessage = true
            } else {
                _messageDisplayFunction(credentials.localParams.parameter, "Sorry! This link has been exipred. Click <router-link :to='/forgot-password'>Here</router-link> to reset again!", 'error')
            }
        })
    },
    [RUN_CHANGE_PASSWORD]({ commit, state, getters }, credentials) {
        _executeApi(Enpoints.EP_CHANGE_PASSWORD, credentials, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.clearAll()
                _messageDisplayFunction(credentials.localParams.parameter, 'password changed successfully', 'success')
            } else {
                if(result.errors && result.errors[0] && result.errors[0].msg){
                    _messageDisplayFunction(credentials.localParams.parameter, result.errors[0].msg, 'error')
                }else{
                    _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
                }
            }
        })

    },
}

//================================functions======================================
function _executeApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = []
        if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        if (getToken == '') { getToken = '' }
        credentials.localParams.parameter.pageLoader = true

        RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                    credentials.localParams.parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            response_array.res_data = data.data
                            callback(false, response_array)
                        } else {
                            if('status' in data && data.status == 401){
                                localStorage.clear();
                                window.location.replace("/")
                            }else{
                                if (typeof data.msg == 'object') {
                                    response_array.res_data = data.msg.msg
                                } else {
                                    response_array.res_data = data.msg
                                }
                                if(data.errors){
                                    response_array.errors = data.errors
                                }
                                callback(true, response_array)
                            }
                        }
                    }
                },
                e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}

function _messageDisplayFunction(getParameter, getMessage, msgType) {
    getParameter.$notify({
        group: 'foo',
        type: msgType,
        text: getMessage,
        duration: 10000,
        closeOnClick: true
    });
    getParameter.notification_msg = getMessage ;
    getParameter.notification_type = msgType ;

    setTimeout(function(){
        getParameter.notification_msg = '' ;
        getParameter.notification_type = '' ;
    }, 10000);
}

function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_INFO", msg)
}

function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) {}
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            // console.log('clear all')
            let data = {}
            let options = {}
            options.forward = true
            localStorage.clear();
            window.location.replace("/")
            // _handleLogout(data, commit, options)
        }
    }
}

function _handleLogout(data, commit, options) {
    // const router = options.router
    // let user = {}
    localStorage.clear();
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js